// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1SovX","buttonsWrapper":"styles_buttonsWrapper__28urh"};